import { render, staticRenderFns } from "./ChannelsPopoutApp.vue?vue&type=template&id=0f91357e"
import script from "./ChannelsPopoutApp.vue?vue&type=script&lang=js"
export * from "./ChannelsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./ChannelsPopoutApp.vue?vue&type=style&index=0&id=0f91357e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports